import React, { createContext, useState } from 'react';

// Create a context for the login popup state with a default value
export const LoginPopupContext = createContext({
    isPopupVisible: false,
    setIsPopupVisible: () => {}
});

export const LoginPopupProvider = ({ children }) => {
    const [isPopupVisible, setIsPopupVisible] = useState(false);

    return (
        <LoginPopupContext.Provider value={{ isPopupVisible, setIsPopupVisible }}>
            {children}
        </LoginPopupContext.Provider>
    );
};
